import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import { ProductBinSchema } from "@redotech/redo-model/inventory/general-listing/general-listing-variant";
import * as z from "zod";

export const ProductBinInputSchema = z.union([
  z.object({ storageLocationId: storageLocationIdFormat.schema }),
  z.object({
    locationId: locationIdFormat.schema,
    binName: z.string().trim().min(1).max(255),
  }),
]);
export type ProductBinInput = z.infer<typeof ProductBinInputSchema>;

export const setProductBins = {
  name: "setProductBins" as const,
  input: z.object({
    productId: productIdFormat.schema,
    bins: z.array(ProductBinInputSchema),
  }),
  output: z.object({ bins: z.array(ProductBinSchema) }),
};
